import { Component, input } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { Route, RouterLink } from '@angular/router';

@Component({
  selector: 'dges-full-length-menu',
  templateUrl: './full-length-menu.component.html',
  standalone: true,
  imports: [MatButton, RouterLink, UpperCasePipe],
  host: {
    style: `
      display: flex;
      flex-direction: row;
      align-items: center;
    `,
  },
})
export class FullLengthMenuComponent {
  readonly fillerNav = input<Route[]>([]);
}
